import React from "react";
import Button from "../componentLibrary/Button";

interface Topic {
  name: string;
  icon: string;
  alt: string;
}

interface TopicsModalProps {
  isOpen: boolean;
  onClose: () => void;
  topics?: Topic[];
}

const TopicsModal = ({
  isOpen,
  onClose,
  topics: customTopics,
}: TopicsModalProps) => {
  if (!isOpen) return null;

  const defaultTopics = [
    {
      name: "Manage Stress",
      icon: "https://d2c85asnp7to29.cloudfront.net/1736194214726-Coming%20soon%20blue.svg",
      alt: "A megaphone with sound coming out of it",
    },
    {
      name: "Achieve Goals",
      icon: "https://d2c85asnp7to29.cloudfront.net/1727289084875-SMART%20Goals%20MAIN%20top%20of%20mountain%20and%20footsteps%20and%20flag%20artboard_top%20of%20mountain%2C%20footsteps%2C%20flag.svg",
      alt: "Footsteps leading to a flag at the top of a mountain",
    },
    {
      name: "Reduce Anxiety",
      icon: "https://d2c85asnp7to29.cloudfront.net/1728271665518-anxiety%20tiger%20with%20grass-01.svg",
      alt: "A tiger hiding in tall grass",
    },
    {
      name: "Reduce Burnout",
      icon: "https://d2c85asnp7to29.cloudfront.net/1728274116506-Burnout%20main%20icon%20person%20laying%20on%20desk%20with%20low%20battery%20sign%20above%20them_A.svg",
      alt: "A person asleep at a desk",
    },
    {
      name: "Address Conflict at Work",
      icon: "https://d2c85asnp7to29.cloudfront.net/1727551387443-Conflict%20effective%20communication-02.svg",
      alt: "Two people smiling at each other. A lightbulb representing an idea floats between them",
    },
    {
      name: "Overcome Imposter Syndrome",
      icon: "https://d2c85asnp7to29.cloudfront.net/1743712869992-imposter%20two%20people%20as%20one.png",
      alt: "Two People",
    },
    {
      name: "Improve Sleep",
      icon: "https://d2c85asnp7to29.cloudfront.net/1728261775304-Sleep%20moon%20bed%20and%20zzz_Sleep%20moon%2C%20bed%2C%20zzz.svg",
      alt: "A person asleep on the moon",
    },
    {
      name: "Give (and Receive) Useful Feedback",
      icon: "https://d2c85asnp7to29.cloudfront.net/1741734409713-Feedback%20main%20icon.svg",
      alt: "A text box with a circle around it",
    },
    {
      name: "Become an Active Listener",
      icon: "https://d2c85asnp7to29.cloudfront.net/1727551387443-Conflict%20effective%20communication-02.svg",
      alt: "Two people smiling at each other. A lightbulb representing an idea floats between them",
    },
    {
      name: "Create a Growth Mindset",
      icon: "https://d2c85asnp7to29.cloudfront.net/1738271342755-growth%20mindset%20tree.png",
      alt: "A tree",
    },
    {
      name: "Leverage the Power of Gratitude",
      icon: "https://d2c85asnp7to29.cloudfront.net/1728264280356-Sunset%20final%20gratitude%20tree_gratitude%20tree%209.svg",
      alt: "A hand holding a tree",
    },
    {
      name: "Manage Loss and Grief",
      icon: "https://d2c85asnp7to29.cloudfront.net/1727368265476-Grief%20main%20icon_grief%20main%20icon%20lower%20down.svg",
      alt: "A two-colored heart with a black-stroked wave down the middle of it and a bi-colored background for each half of the heart",
    },
  ];

  const topics = customTopics || defaultTopics;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-electrum">
            Full List of Skill-Building Areas
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {topics.map((topic, index) => (
            <div
              key={index}
              className="p-4 bg-electrum-50 rounded-lg border border-electrum-200 flex items-center space-x-3"
            >
              <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
                <img src={topic.icon} alt={topic.alt} className="w-6 h-6" />
              </div>
              <p className="text-gray-800 font-medium text-sm">{topic.name}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <Button variant="primary" onClick={onClose} className="px-8 py-3">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopicsModal;
